import React from 'react';

import useTranslate from '@src/i18n/useTranslate';
import { formatCents } from '@src/common';
import { Total, PurchaseResume } from './styles';
import { DirectLink } from '@src/core/buyerApiClient';

interface DrawerProps {
  directLink: DirectLink;
  showTotal?: boolean;
}

export const PaymentSummary = (props: DrawerProps) => {
  const { directLink, showTotal = false } = props;

  const { i18n } = useTranslate();

  return (
    <>
      <PurchaseResume>
        {showTotal ? (
          <Total>
            <p>{i18n('direct_link_summary_total')}</p> <p>{formatCents(directLink.totalAmountCents)}</p>
          </Total>
        ) : null}
      </PurchaseResume>
    </>
  );
};

export default PaymentSummary;
